/* Swubie angle listicles: scroll reveal, sticky CTA, and the ports of the V2 product page
   buy box (gallery, pack select, price in the CTA, pre-order, rating bar, Ajax cart drawer)
   and review carousel. Class selectors only. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var root = document.querySelector('#sla-wrapper');
    if (!root) return;
    var hasIO = 'IntersectionObserver' in window;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Scroll reveal ---------- */
    var reveals = root.querySelectorAll('.sla-reveal');
    if (hasIO) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { obs.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('visible'); });
    }

    /* ---------- Sticky CTA: after the hero, hidden while the buy box is in view ---------- */
    var sticky = root.querySelector('.sla-sticky');
    var hero = root.querySelector('.sla-hero');
    var buybox = root.querySelector('.sv2');
    if (sticky && hero && buybox && hasIO) {
      var heroIn = true, boxIn = false;
      var upd = function () { sticky.classList.toggle('hidden', heroIn || boxIn); };
      new IntersectionObserver(function (e) { heroIn = e[0].isIntersecting; upd(); }, { threshold: 0 }).observe(hero);
      new IntersectionObserver(function (e) { boxIn = e[0].isIntersecting; upd(); }, { threshold: 0.05 }).observe(buybox);
    }

    /* ---------- Gallery slider ---------- */
    var track = root.querySelector('.sv2-gallery__track');
    if (track) {
      var slides = track.querySelectorAll('.sv2-gallery__slide');
      var gDots = root.querySelectorAll('.sv2-gallery__dot');
      var thumbs = root.querySelectorAll('.sv2-gallery__thumb');
      var cur = 0;
      var setActive = function (i) {
        cur = i;
        gDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      };
      var goTo = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      };
      gDots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.getAttribute('data-index')); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-index')); }); });
      root.querySelectorAll('.sv2-gallery__arrow').forEach(function (a) {
        a.addEventListener('click', function () { goTo(cur + parseInt(a.getAttribute('data-dir'), 10)); });
      });
      var gt;
      track.addEventListener('scroll', function () {
        clearTimeout(gt);
        gt = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setActive(i); }, 80);
      });
    }

    /* ---------- Pack select + price and pre-order state in the CTA ---------- */
    var variantInput = root.querySelector('.sla-variant-id');
    var btn = root.querySelector('.sla-atc-btn');
    var label = btn ? btn.querySelector('.sla-atc-label') : null;
    var was = btn ? btn.querySelector('.sla-atc-was') : null;
    var packs = root.querySelectorAll('.sla-pack');
    function ctaText(pack) {
      if (pack.getAttribute('data-preorder') === 'true') return 'Pre-order';
      var base = btn.getAttribute('data-cta-base') || 'In winkelmand';
      var price = pack.getAttribute('data-price');
      return price ? base + ' · ' + price : base;
    }
    function selectPack(pack) {
      packs.forEach(function (p) { p.classList.remove('selected'); p.setAttribute('aria-pressed', 'false'); });
      pack.classList.add('selected');
      pack.setAttribute('aria-pressed', 'true');
      if (variantInput) variantInput.value = pack.getAttribute('data-variant-id');
      if (label) label.textContent = ctaText(pack);
      if (was) was.textContent = pack.getAttribute('data-preorder') === 'true' ? '' : (pack.getAttribute('data-compare') || '');
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () { selectPack(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPack(p); } });
    });
    var initial = root.querySelector('.sla-pack.selected') || packs[0];
    if (initial) selectPack(initial);

    /* ---------- Rating bar: fill + count up when in view ---------- */
    root.querySelectorAll('.sv2-progress[data-pct]').forEach(function (bar) {
      if (reduce || !hasIO) return;
      bar.classList.add('is-armed');
      bar.getBoundingClientRect();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(bar);
          requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('is-in'); }); });
          var lab = bar.querySelector('.sv2-progress__label');
          var target = parseInt(bar.getAttribute('data-pct'), 10);
          if (!lab || !target) return;
          var rest = lab.textContent.replace(/^\s*\d+/, '');
          var t0 = null;
          var step = function (t) {
            if (!t0) t0 = t;
            var p = Math.min(1, (t - t0) / 1800);
            lab.textContent = Math.round(target * (1 - Math.pow(1 - p, 5))) + rest;
            if (p < 1) requestAnimationFrame(step);
          };
          lab.textContent = '0' + rest;
          requestAnimationFrame(step);
        });
      }, { threshold: 0.6 });
      io.observe(bar);
    });

    /* ---------- Review carousel ---------- */
    root.querySelectorAll('.sla-tcar').forEach(function (car) {
      var t = car.querySelector('.sla-tcar__track');
      var cards = t ? t.querySelectorAll('.sla-tcar__card') : [];
      var dotsWrap = car.querySelector('.sla-tcar__dots');
      if (!t || !cards.length) return;
      var idx = 0, dotEls = [];
      var mark = function (i) { idx = i; dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); };
      var go = function (i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        t.scrollTo({ left: cards[i].offsetLeft - t.offsetLeft, behavior: 'smooth' });
        mark(i);
      };
      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'sla-tcar__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Beoordeling ' + (i + 1));
          d.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(d);
          dotEls.push(d);
        });
      }
      car.querySelectorAll('.sla-tcar__arrow').forEach(function (a) {
        a.addEventListener('click', function () { go(idx + parseInt(a.getAttribute('data-dir'), 10)); });
      });
      var st;
      t.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var stepW = cards[1] ? (cards[1].offsetLeft - cards[0].offsetLeft) : t.clientWidth;
          var i = Math.round(t.scrollLeft / stepW);
          if (i !== idx) mark(Math.max(0, Math.min(cards.length - 1, i)));
        }, 80);
      });
    });

    /* ---------- Ajax add to cart (Olivia cart-drawer pattern) ---------- */
    var form = root.querySelector('.sla-atc-form');
    if (!form || !btn || !label) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var orig = label.textContent;
      label.textContent = 'Toevoegen...';
      btn.disabled = true;

      var body = new FormData();
      body.append('id', variantInput.value);
      body.append('quantity', '1');
      body.append('sections', 'cart-drawer,cart-icon-bubble');

      fetch('/cart/add.js', { method: 'POST', body: body })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          if (data.sections) {
            var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
            var inner = document.querySelector('#CartDrawer .drawer__inner');
            var footer = document.querySelector('#CartDrawer .drawer__footer');
            var newInner = parsed.querySelector('.drawer__inner');
            var newFooter = parsed.querySelector('.drawer__footer');
            if (inner && newInner) inner.innerHTML = newInner.innerHTML;
            if (footer && newFooter) footer.innerHTML = newFooter.innerHTML;

            var parsedIcon = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var bubble = document.getElementById('cart-icon-bubble');
            var newBubble = parsedIcon.querySelector('.shopify-section');
            if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;

            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              drawer.classList.remove('is-empty');
              if (typeof drawer.open === 'function') drawer.open();
            }
          }
          label.textContent = 'Toegevoegd!';
          setTimeout(function () { label.textContent = orig; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          label.textContent = orig;
          btn.disabled = false;
          form.submit();
        });
    });
  });
})();
